import { render, staticRenderFns } from "./RuwangView.vue?vue&type=template&id=520a59d8&scoped=true&"
import script from "./RuwangView.vue?vue&type=script&lang=js&"
export * from "./RuwangView.vue?vue&type=script&lang=js&"
import style0 from "./RuwangView.vue?vue&type=style&index=0&id=520a59d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520a59d8",
  null
  
)

export default component.exports